// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly; both side-effect imports must initialize `AdminSelectChoices` before its exports are read.
import "./template-helpers/choice-items.js";
import "./template-helpers/sp-select-tag.js";

export const {
  selectValue,
  selectValues,
  selectableValues,
  spSelectName,
  spSelectTag,
  spSelectSearchable,
  blankSelectItem,
} = globalThis.AdminSelectChoices;
